let promotionPresenter = null;

export function registerInstallPromotionPresenter(presenter) {
    promotionPresenter = typeof presenter === 'function' ? presenter : null;
    return () => {
        if (promotionPresenter === presenter) {
            promotionPresenter = null;
        }
    };
}

export function notifyInstallPromotionSuccess(context = {}) {
    if (!promotionPresenter) return;
    Promise.resolve(promotionPresenter({
        trigger: 'success',
        waitForChoice: false,
        context
    })).catch(() => {});
}

export function awaitInstallPromotionAfterSuccess(context = {}) {
    if (!promotionPresenter) {
        return Promise.resolve({shown: false});
    }
    return Promise.resolve(promotionPresenter({
        trigger: 'success',
        waitForChoice: true,
        context
    })).catch(() => ({shown: false}));
}
